/*
 * @Description: '关于我们'页面所有路由
*/

export default [
  {
    path: 'search',
    component: resolve => require(['@/views/search'], resolve),
    name: 'search',
    meta: {
      nav: '搜索'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/search.js